import Navegacao from '../components/Navegacao';
import React, { Component } from 'react';
import central from '../api/Central';
import Error from '../components/Error';
import Loader from '../components/Loader';
import Alert from '../components/Alert';

class ReligarDetalhe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            servico: null,
            erro: null,
            sucesso: false
        }
    }

    religa() {
        this.setState({ carregando: true });
        central.requestAndCatch("POST", "/religar/" + this.props.match.params.id, null,
            (payload) => {
                console.log("SUCESSO");
                this.setState({ sucesso: true });
            },
            (erro) => {
                this.setState({ erro: erro });
            },
            () => {
                this.setState({ carregando: false });
            });
    }

    render() {

        var erro = (<Error msg={this.state.erro} disabled={this.state.carregando} onButtonClick={this.religa.bind(this)} buttonLabel="Tentar Novamente" />);

        var sucesso = (<React.Fragment><Alert type="success"><h2>Pronto</h2>A religação foi solicitada com sucesso. O serviço será reestabelecido em breve.</Alert></React.Fragment>);

        var componente = (
            <React.Fragment>
                <p>Atenção:</p>
                <p>Para religar o serviço, você precisa concordar com os seguintes pontos:</p>
                <ol>
                    <li>Esta é uma religação provisória para dar tempo do nosso sistema identificar seu pagamento.</li>
                    <li>Caso seu pagamento não seja identificado nos próximos dias, o serviço poderá ser bloqueado novamente e só poderá ser religado mediante confirmação do pagamento.</li>
                    <li>A religação do serviço pode demorar algumas horas até ser efetivada.</li>
                </ol>
                <div>
                    <button onClick={this.religa.bind(this)} disabled={this.state.carregando}>
                        {this.state.carregando ?
                            <React.Fragment><Loader /> Aguarde... </React.Fragment>
                            : "Solicitar Religação Provisória"}
                    </button>
                </div>
            </React.Fragment>
        );

        return (
            <section className="container">
                <Navegacao link="/religar" titulo="Religar serviço" />
                {(this.state.sucesso ? sucesso : (this.state.erro ? erro : componente))}
            </section>
        );
    }
}

export default ReligarDetalhe;